module.exports = __webpack_public_path__ + "img/pic_administration_customer.e91b8710.jpg";